import {useQuery} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import axiosInstance from '../../../axiosConfig';
import {IApiDataResponse} from '../../../dto/API.dto';
import {ITaskMessage} from '../../../dto/Task.dto';

export const useRqGetMessagesForScriptVerification = (taskId: number) => {
  return useQuery({
    queryKey: [`v1/task/${taskId}/content-verification`],
    queryFn: () => getMessagesForScriptVerification(taskId),
    refetchOnWindowFocus: false,
  });
};

const getMessagesForScriptVerification = (taskId: number) => {
  return axiosInstance
    .get(`v1/task/${taskId}/content-verification`)
    .then((response: AxiosResponse<IApiDataResponse<ITaskMessage>>) => {
      return response.data.data;
    });
};
